export default __webpack_public_path__ + "static/media/icon_5_on.82afd167.png";